<a class="media-sound" *ngIf="media.type === 'SND'" [attr.href]="stockageUrl + media.url" target="_blank">
    <img src="https://static.myskillcamp.com/images/icon/icon-camp/icon_library_sound.svg" />

    <div class="media-sound__desc">
        <p class="media-sound__name">{{ media.title | truncate: '14' }}</p>
        <p class="media-sound__size">{{ media.size | fileSize }} <span>{{ 'words.edited' | translate }} {{ media.updatedAt | date : 'dd-MM-yyyy' }}</span></p>
    </div>
</a>
